import {Component, Directive, OnDestroy} from "@angular/core";
import {Observable} from "rxjs";
import {StandaloneFormService} from "../services/standalone-form.service";
import {AbstractControl, FormGroup} from "@angular/forms";
import {WINDOW_RESIZED$} from "../../app.component";
import {map} from "rxjs/operators";

@Directive()
export abstract class StandaloneFormComponent implements OnDestroy {

	protected constructor(private standaloneFormService: StandaloneFormService) {
	}

	isMidScreenOrSmaller(): Observable<boolean> {
		return WINDOW_RESIZED$.asObservable().pipe(map(outerWidth => outerWidth < 991));
	}

	/**
	 * Use in case when form service is determined in the OnInit method or passed via @Input
	 */
	setStandaloneFormService(formService: StandaloneFormService) {
		this.standaloneFormService = formService;
	}

	ngOnDestroy(): void {
		this.standaloneFormService.destroy()
	}

	isFormInvalid(): Observable<boolean> {
		return this.standaloneFormService.isFormValid().pipe(map(valid => !valid))
	}

	isInvalid(...path: string[]) {
		return this.standaloneFormService.isInvalid(StandaloneFormService.FORM_KEY, ...path);
	}

	updateFormControl(controlName: string, value: any) {
		return this.standaloneFormService.updateFormControl(controlName, value, StandaloneFormService.FORM_KEY);
	}

	getValidationErrors(...path: string[]): Observable<string> {
		return this.standaloneFormService.getErrorsString(StandaloneFormService.FORM_KEY, ...path);
	}

	blockInput(formControlName: string) {
		this.standaloneFormService.blockInput(StandaloneFormService.FORM_KEY, formControlName);
	}

	getValueFor(formControlName: string): string {
		return this.standaloneFormService.getValueFor(formControlName, StandaloneFormService.FORM_KEY);
	}

	onValueChange(formControlName: string): Observable<any> {
		return this.standaloneFormService.onValueChange(formControlName, StandaloneFormService.FORM_KEY);
	}

	getFormControl(controlName: string): AbstractControl {
		return this.standaloneFormService.getFormControl(StandaloneFormService.FORM_KEY, controlName);
	}

	getForm(): FormGroup {
		return this.standaloneFormService.getForm(StandaloneFormService.FORM_KEY);
	}
}
